/**
 * Re-renders every Quill formula span in a saved HTML string from its
 * data-value LaTeX through window.katex (which injects the MathLive
 * compatibility macros — see setupKatex). Saved content can carry stale
 * renders (e.g. red \exponentialE error text baked in before the macros
 * existed), so display surfaces should pass content through this before
 * dangerouslySetInnerHTML. Content without formulas is returned as-is.
 */
export function renderFormulasInHtml(html: string): string {
	if (!html || !html.includes('ql-formula')) return html;
	const katex = (
		window as unknown as {
			katex?: { renderToString(expr: string, options?: unknown): string };
		}
	).katex;
	if (!katex) return html;
	const doc = new DOMParser().parseFromString(html, 'text/html');
	doc.querySelectorAll('span.ql-formula[data-value]').forEach((span) => {
		const value = span.getAttribute('data-value');
		if (!value) return;
		try {
			span.innerHTML = katex.renderToString(value, { throwOnError: false });
		} catch {
			// Keep the stored render for this formula.
		}
	});
	return doc.body.innerHTML;
}
